

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { API, PageModel, Tag, Team, TeamAPI } from '@brg/api';
import { ModerationType } from 'shared/pages/teams/const/ModerationTypes';
import { ACTIVE_ARCHIVE_TEAM_STATUS, DRAFT_TEAM_STATUS, PUBLISHED_TEAM_STATUS } from 'shared/helpers/teamsStatus';

export const fetchUserChannel = createAsyncThunk('channel/fetchUserChannel', 
    async (args: any, { getState, dispatch }: { getState: any, dispatch: any }) => {
    const { accountId } = args;
    const { data } = getState();

    if (data) {
        return null;
    }

    const json = await API.Json(
        TeamAPI.GetList({ 
            moderationTypes: [
                // ModerationType.Channel, 
                ModerationType.ChannelGroupOrCourse,
                ModerationType.Outer
            ], 
            ownerOrMemberIds: [accountId],
            statuses: [
                ACTIVE_ARCHIVE_TEAM_STATUS,
                DRAFT_TEAM_STATUS,
                PUBLISHED_TEAM_STATUS,
            ] 
        })
    )
    return json
});


export interface UserChannelState {
    data: PageModel<Team<"Global">> | undefined;
    activeChannel: Team<'Global'> | undefined;
    loading: boolean;
    error: string | null;
}

const INITIAL_STATE = {
    data: undefined,
    activeChannel: undefined,
    loading: false,
    error: ''
}

const userChannelSlice = createSlice({
    name: 'channel',
    initialState: INITIAL_STATE,
    reducers: {
        reset: (state) => {
            state = INITIAL_STATE;
        },
        setChannel: (state,{ payload }) => {
            state.activeChannel = payload.activeChannel
        }
    },
    extraReducers: {
        [fetchUserChannel.fulfilled.toString()]: (state, action) => {
            state.loading = false;
            state.data = action.payload;
        },
        [fetchUserChannel.rejected.toString()]: (state) => {
            state.loading = false;
            state.data = undefined;
            state.error = state.error;
        },
        [fetchUserChannel.pending.toString()]: (state) => {
            state.loading = true;
        },
    },
});

export default userChannelSlice;
export const userChannelSliceReducer = userChannelSlice.reducer;
export const getUserChannel = (store: { channel: UserChannelState }): UserChannelState => store.channel;


import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { API, PageModel, Tag, Team, TeamAPI } from '@brg/api';
import { ModerationType } from 'shared/pages/teams/const/ModerationTypes';
import { ACTIVE_ARCHIVE_TEAM_STATUS, DRAFT_TEAM_STATUS, PUBLISHED_TEAM_STATUS } from 'shared/helpers/teamsStatus';

export const fetchUserChannel = createAsyncThunk('channel/fetchUserChannel', 
    async (args: any, { getState, dispatch }: { getState: any, dispatch: any }) => {
    const { accountId } = args;
    const { data } = getState();

    if (data) {
        return null;
    }

    const json = await API.Json(
        TeamAPI.GetList({ 
            moderationTypes: [
                // ModerationType.Channel, 
                ModerationType.ChannelGroupOrCourse,
                ModerationType.Outer
            ], 
            ownerOrMemberIds: [accountId],
            statuses: [
                ACTIVE_ARCHIVE_TEAM_STATUS,
                DRAFT_TEAM_STATUS,
                PUBLISHED_TEAM_STATUS,
            ] 
        })
    )
    return json
});


export interface UserChannelState {
    data: PageModel<Team<"Global">> | undefined;
    activeChannel: Team<'Global'> | undefined;
    loading: boolean;
    error: string | null;
}

const INITIAL_STATE = {
    data: undefined,
    activeChannel: undefined,
    loading: false,
    error: ''
}

const userChannelSlice = createSlice({
    name: 'channel',
    initialState: INITIAL_STATE,
    reducers: {
        reset: (state) => {
            state = INITIAL_STATE;
        },
        setChannel: (state,{ payload }) => {
            state.activeChannel = payload.activeChannel
        }
    },
    extraReducers: {
        [fetchUserChannel.fulfilled.toString()]: (state, action) => {
            state.loading = false;
            state.data = action.payload;
        },
        [fetchUserChannel.rejected.toString()]: (state) => {
            state.loading = false;
            state.data = undefined;
            state.error = state.error;
        },
        [fetchUserChannel.pending.toString()]: (state) => {
            state.loading = true;
        },
    },
});

export default userChannelSlice;
export const userChannelSliceReducer = userChannelSlice.reducer;
export const getUserChannel = (store: { channel: UserChannelState }): UserChannelState => store.channel;
